import {
    ACCESSORIES_SHM_TITLE,
    ACCESSORIES_SHM_TYPE,
    CONTAINER_SHM_TITLE,
    CONTAINER_SHM_TYPE,
    COMPONENT_SHM_TITLE,
    COMPONENT_SHM_TYPE,
    DRYER_SHM_TITLE,
    DRYER_SHM_TYPE,
    FILTER_AND_ABSORBER_SHM_TITLE,
    FILTER_AND_ABSORBER_SHM_TYPE,
    OIL_FREE_PISTON_COMPRESSOR_SHM_TITLE,
    OIL_FREE_PISTON_COMPRESSOR_SHM_TYPE,
    OIL_FREE_SCREW_COMPRESSOR_SHM_TITLE,
    OIL_FREE_SCREW_COMPRESSOR_SHM_TYPE,
    PISTON_COMPRESSOR_SHM_TITLE,
    PISTON_COMPRESSOR_SHM_TYPE,
    RECEIVER_SHM_TITLE,
    RECEIVER_SHM_TYPE,
    SCREW_COMPRESSOR_SHM_TITLE,
    SCREW_COMPRESSOR_SHM_TYPE,
    CRAFTSMAN_COMPRESSOR_TITLE,
    CRAFTSMAN_COMPRESSOR_TYPE,
    SCROLL_COMPRESSOR_TITLE,
    SCROLL_COMPRESSOR_TYPE,
} from './secondHandMachinesTypeNames';

export const personData = [
    {
        field_email: 't.wenzel@boge.de',
        field_image: [
            {
                field_media_image: '/sites/default/files/Wenzel_3.jpg',
                alt: 'Thomas Wenzel image',
            },
        ],
        field_phone: '+49 5206 601-164',
        field_position: 'Business Unit Manager',
        title: 'Thomas Wenzel',
    },
];

export const sectionsData = [
    {
        sectionTitle: 'usedPistonCompressors',
        sectionText: 'usedPistonCompressorsText',
        sectionAccordionItems: [
            {
                title: OIL_FREE_PISTON_COMPRESSOR_SHM_TITLE,
                value: OIL_FREE_PISTON_COMPRESSOR_SHM_TYPE,
            },
            {
                title: PISTON_COMPRESSOR_SHM_TITLE,
                value: PISTON_COMPRESSOR_SHM_TYPE,
            },
        ],
    },
    {
        sectionTitle: 'usedScrewCompressors',
        sectionText: 'usedScrewCompressorsText',
        sectionAccordionItems: [
            {
                title: OIL_FREE_SCREW_COMPRESSOR_SHM_TITLE,
                value: OIL_FREE_SCREW_COMPRESSOR_SHM_TYPE,
            },
            {
                title: SCREW_COMPRESSOR_SHM_TITLE,
                value: SCREW_COMPRESSOR_SHM_TYPE,
            },
        ],
    },
    {
        sectionTitle: 'usedCraftsmanCompressors',
        sectionText: 'usedCraftsmanCompressorsText',
        sectionAccordionItems: [
            {
                title: CRAFTSMAN_COMPRESSOR_TITLE,
                value: CRAFTSMAN_COMPRESSOR_TYPE,
            },
        ],
    },
    {
        sectionTitle: 'usedScrollCompressors',
        sectionText: 'usedScrollCompressorsText',
        sectionAccordionItems: [
            {
                title: SCROLL_COMPRESSOR_TITLE,
                value: SCROLL_COMPRESSOR_TYPE,
            },
        ],
    },
    {
        sectionTitle: 'usedCompressorAccessories',
        sectionText: 'usedCompressorAccessoriesText',
        sectionAccordionItems: [
            {
                title: DRYER_SHM_TITLE,
                value: DRYER_SHM_TYPE,
            },
            {
                title: FILTER_AND_ABSORBER_SHM_TITLE,
                value: FILTER_AND_ABSORBER_SHM_TYPE,
            },
            {
                title: ACCESSORIES_SHM_TITLE,
                value: ACCESSORIES_SHM_TYPE,
            },
            {
                title: RECEIVER_SHM_TITLE,
                value: RECEIVER_SHM_TYPE,
            },
        ],
    },
    {
        sectionTitle: 'usedContainer',
        sectionText: null,
        sectionAccordionItems: [
            {
                title: CONTAINER_SHM_TITLE,
                value: CONTAINER_SHM_TYPE,
            },
        ],
    },
    {
        sectionTitle: 'componentWithoutRefurbishment',
        sectionText: null,
        sectionAccordionItems: [
            {
                title: COMPONENT_SHM_TITLE,
                value: COMPONENT_SHM_TYPE,
            },
        ],
    },
];
